import { Box, Button, Container, Grid, Paper, TextField, Typography, FormControl, InputLabel, Select, MenuItem, Stepper, Step, StepLabel, Backdrop, CircularProgress, FormHelperText, Divider } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import UserService from "../../UserPlugin/service/api/user";
import { useEffect, useState } from "react";
import { Form, useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import CustomButton from "../../../core/components/ui/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import CustomHeader from "../../../core/components/common/custom-header.component";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import OrganizationService from "../services/api/organization";
import { useUser } from "../../UserPlugin/hooks/useUser";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import SavePasswordDialogComponent from "../components/save-password-dialog.component";
import { useSnackbar } from "notistack";
import useAdminProfileUtils from "../../ProfilePlugin/utils/useAdminProfileUtils";
import CustomTextField from "../../../core/components/ui/CustomTextfield";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export default function OrganizationCreatePage ({createdUserData}) {

    const [firstname, setFirstname] = useState('');
        const [lastname, setLastname] = useState('');
        const [email, setEmail] = useState('');
        const [birthdate, setBirthdate] = useState(null);
        const [middlename, setMiddleName] = useState("");
        const [contact_no, setContactNumber] = useState("");
        const [org_name, setOrgName] = useState("");
        const [description, setDescription] = useState("");
        const [contact_email, setContactEmail] = useState("");
        const [contact_phone, setContactPhone] = useState("");
        const [id_type, setIdType] = useState("");
        const [id_no, setIdNumber] = useState("");
        const [subscription_type, setSubscriptionType] = useState('')
        
        const [loading, setLoading] = useState(false);
        const [success, setSuccess] = useState(false);
        const [orgErrors, setOrgErrors] = useState({});
        const [userErrors, setUserErrors] = useState({});
        const [openSavePassword, setOpenSavePassword] = useState(false);
        const [createUserData, setCreateUserData] = useState(null);
        const [progress, setProgress] = useState(0);

        const {enqueueSnackbar} = useSnackbar();
    
        const location = useLocation();
        const navigate = useNavigate();
        const {listUser, userList} = useUser();
        const { isFetchingIDTypes, idTypes, getIDTypesUtil} = useAdminProfileUtils();

        const handleBack = () => {
            navigate(-1); 
        }

        const handleChange = (setter, field) => (event) => {
            setter(event.target.value);
        };

        const handleChangeEmail = (setter) => (event) => {
            setter(event.target.value);
            validateEmailField(event.target.value)
        }

        const validateContactEmailField = (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setOrgErrors((prev) => ({
                ...prev,
                contact_email: value === ''
                ? 'Email is required'
                : !emailRegex.test(value)
                ? 'Invalid email format'
                : '',
            }));
        };

        const validateEmailField = (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
           
            setUserErrors((prev) => ({
                ...prev,
                email: value === ''
                ? 'Email is required'
                : !emailRegex.test(value)
                ? 'Invalid email format'
                : '',
            }));
        };

        const validatePhoneField = (value) => {
            const phoneRegex = /^[0-9+\-\s()]{7,15}$/;
            setUserErrors((prev) => ({
                ...prev,
                contact_phone: value === ''
                ? 'Phone number is required'
                : !phoneRegex.test(value)
                ? 'Invalid phone number'
                : '',
            }));
           
        };

        const validateNumberField = (value) => {
            const phoneRegex = /^[0-9+\-\s()]{7,15}$/;
            
            setUserErrors((prev) => ({
                ...prev,
                contact_no: value === ''
                ? 'Mobile number is required'
                : !phoneRegex.test(value)
                ? 'Invalid mobile number'
                : '',
            }));
        };
    
        const handleChangeSubType = (e) => {
            setSubscriptionType(e.target.value)
        }

        const handleClose = () => {
            setOpenSavePassword(false)
        }
    
        const handleSubmit = async () => {
    const orgErrors = {};
    const userErrors = {};

    // Required field checks
    if (!org_name) orgErrors.org_name = "Organization name is required";
    if (!contact_email) orgErrors.contact_email = "Contact email is required";
    if (!description) orgErrors.description = "Description is required";
    if (!contact_phone) orgErrors.contact_phone = "Contact phone is required";
    if (!id_type) orgErrors.id_type = "ID type is required";
    if (!id_no) orgErrors.id_no = "ID number is required";
    if (!subscription_type) orgErrors.subscription_type = "Subscription type is required";

    if (!firstname) userErrors.firstname = "First name is required";
    if (!lastname) userErrors.lastname = "Last name is required";
    if (!email) userErrors.email = "Email is required";
    if (!contact_no) userErrors.contact_no = "Contact number is required";
    if (!birthdate) userErrors.birthdate = "Date of birth is required";

    // Format validations
    validateContactEmailField(contact_email);
    validatePhoneField(contact_phone);
    validateEmailField(email);
    validateNumberField(contact_no);

    // Collect current error states after validation
    const currentOrgErrors = {
        ...orgErrors,
        ...((contact_email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact_email)) ? {} : { contact_email: 'Invalid email format' }),
        ...((contact_phone && /^[0-9+\-\s()]{7,15}$/.test(contact_phone)) ? {} : { contact_phone: 'Invalid phone number' }),
    };

    const currentUserErrors = {
        ...userErrors,
        ...((email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) ? {} : { email: 'Invalid email format' }),
        ...((contact_no && /^[0-9+\-\s()]{7,15}$/.test(contact_no)) ? {} : { contact_no: 'Invalid mobile number' }),
    };

    setOrgErrors(currentOrgErrors);
    setUserErrors(currentUserErrors);

    if (Object.keys(currentOrgErrors).some(k => currentOrgErrors[k]) || Object.keys(currentUserErrors).some(k => currentUserErrors[k])) {
        return;
    }

    setLoading(true);

    try {
        const orgPayload = {
            org_name,
            description,
            contact_email,
            contact_phone,
            firstname,
            middlename,
            lastname,
            email,
            contact_no,
            birthdate: birthdate ? dayjs(birthdate).format("YYYY-MM-DD") : null,
            id_type,
            id_no,
            subscription_type,
        };

        const orgResponse = await OrganizationService.createOrg(orgPayload);
        setCreateUserData(orgResponse?.data?.data?.user);
        setSuccess(true);
        setOpenSavePassword(true);
    } catch (error) {
        const errorMessage = error?.response?.data?.error_message || error.message;
        enqueueSnackbar(errorMessage, {
            variant: "error",
            autoHideDuration: 4000
        });
    } finally {
        setLoading(false);
    }
        };


        const isOrgStepValid = () =>
            org_name && description && contact_email && contact_phone && id_type && id_no && subscription_type;
        
        const isUserStepValid = () =>
            firstname && middlename && lastname && email && contact_no && birthdate;
        

        const getActiveStep = () => {
            if (!isOrgStepValid()) return 0;
            if (!isUserStepValid()) return 1;
            return 2; // All valid
        };
        

        useEffect(() => {
            getIDTypesUtil();
        }, []);

    return(
        <>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
            open={loading}
        >
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <CircularProgress
                    color="inherit"
                    value={progress} // Progress must be a value between 0 and 100
                    size={60}
                />
                <Typography mt={2} sx={{color:"#fff"}}>
                    Creating...
                </Typography>
            </Box>
            
        </Backdrop>

            
            {/* <Container maxWidth="lg"> */}
                <Box sx={{ mt: 5 }}>
                    <Container maxWidth="lg">
                        <CustomButton
                        variant="text"
                        startIcon={<ArrowBackIcon fontSize="small" />}
                        label="Back to Organization"
                        customStyles={{ fontSize: 14, mt: 1, mb: 2, ml: "-20px" }}
                        onClick={handleBack}
                        />

                        <Grid container spacing={3}>
                            <Grid item size={{xs: 12}} sx={{ p: 3, borderRadius: 3, border: "1px solid #e5edf6" }}>
                                <Typography variant="h6">Create Organization</Typography>
                                <Typography mb={2}>Add a new organization by entering its details and contact information.</Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 5 }}>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>Organization Name</Typography>
                                    <CustomTextField
                                    placeholder="e.g. ABC Corporation"
                                    variant="outlined"
                                    value={org_name}
                                    onChange={(e) => setOrgName(e.target.value)}
                                    fullWidth
                                    hiddenLabel
                                    helperText={orgErrors.org_name}
                                    />
                                </Box>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>Description</Typography>
                                    <CustomTextField
                                    placeholder="e.g. Technology solutions company"
                                    variant="outlined"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    fullWidth
                                    hiddenLabel
                                    helperText={orgErrors.description}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", gap: 2 }}>
                                    <Box sx={{ flex: 1 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>Business Email</Typography>
                                    <CustomTextField
                                        placeholder="e.g. info@radix.co"
                                        variant="outlined"
                                        value={contact_email}
                                        onChange={(e) => {
                                        const val = e.target.value;
                                        setContactEmail(val);
                                        validateContactEmailField(val);
                                        }}
                                        fullWidth
                                        hiddenLabel
                                        helperText={orgErrors.contact_email}
                                    />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>Phone Number</Typography>
                                    <CustomTextField
                                        placeholder="e.g. 032171234567"
                                        variant="outlined"
                                        value={contact_phone}
                                        onChange={(e) => {
                                        const val = e.target.value;
                                        setContactPhone(val);
                                        validatePhoneField(val);
                                        }}
                                        fullWidth
                                        hiddenLabel
                                        helperText={orgErrors.contact_phone}
                                    />
                                    </Box>
                                </Box>
                                
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>Subscription Type</Typography>
                                    <FormControl fullWidth 
                                    sx={{'& .MuiFormHelperText-root': {
                                        color: 'red',
                                        fontSize: 11,
                                        margin: 0
                                    }, '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                        borderColor: '#e5edf6', // <-- custom border color here
                                        },
                                        '&:hover fieldset': {
                                        borderColor: '#e5edf6',
                                        },
                                        '&.Mui-focused fieldset': {
                                        borderColor: '#e5edf6',
                                        },
                                    }}}>
                                    <Select
                                        value={subscription_type}
                                        onChange={handleChangeSubType}
                                        displayEmpty
                                        renderValue={(selected) => selected || <Typography sx={{ fontSize: 13, color: "#b8b8b8" }}>Select Subscription</Typography>}
                                        sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '4px',
                                            '& fieldset': {
                                            borderColor: '#e5edf6'
                                            },
                                        },
                                        '& .MuiSelect-select': {
                                            padding: '10px 14px',
                                            minHeight: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }
                                        }}
                                    >
                                        <MenuItem value="Annual">Annual</MenuItem>
                                    </Select>
                                    <FormHelperText>{orgErrors.subscription_type}</FormHelperText>
                                    </FormControl>
                                </Box>
                                <Divider />
                                <Typography mb={2} sx={{fontWeight:'bold'}}>User Information</Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <Grid container spacing={2} >
                                        <Grid item size={{xs: 12, sm: 4}} sx={{  }}>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                    First Name
                                                </Typography>
                                                <CustomTextField
                                                    placeholder="e.g. Juan"
                                                    variant="outlined"
                                                    value={firstname}
                                                    onChange={(e) => setFirstname(e.target.value)}
                                                    fullWidth
                                                    multiline={false}
                                                    hiddenLabel
                                                    helperText={userErrors.firstname}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item size={{xs: 12, sm: 4}} sx={{  }}>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                    Middle Name
                                                </Typography>
                                                <CustomTextField
                                                    placeholder="Middle Name"
                                                    variant="outlined"
                                                    value={middlename}
                                                    onChange={(e) => setMiddleName(e.target.value)}
                                                    fullWidth
                                                    multiline={false}
                                                    hiddenLabel
                                                    helperText={userErrors.middlename}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item size={{xs: 12, sm: 4}} sx={{  }}>
                                            <Box>
                                                <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                    Last Name
                                                </Typography>
                                                <CustomTextField
                                                    placeholder="e.g. Dela Cruz"
                                                    variant="outlined"
                                                    value={lastname}
                                                    onChange={(e) => setLastname(e.target.value)}
                                                    fullWidth
                                                    multiline={false}
                                                    hiddenLabel
                                                    helperText={userErrors.lastname}
                                                />
                                            </Box>
                                        </Grid>
                                        </Grid>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                Email
                                            </Typography>
                                            <CustomTextField
                                                placeholder="e.g. juandelacruz@mail.com"
                                                variant="outlined"
                                                value={email}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setEmail(value);
                                                    validateEmailField(value);
                                                }}
                                                fullWidth
                                                multiline={false}
                                                hiddenLabel
                                                helperText={userErrors.email}
                                            />
                                        </Box>
                                        <Box sx={{ display: "flex", gap: 2 }}>
                                            <Box sx={{ flex: 1 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>ID Type</Typography>
                                            <FormControl fullWidth 
                                                sx={{'& .MuiFormHelperText-root': {
                                                    color: 'red',
                                                    fontSize: 11,
                                                    margin: 0
                                                }, '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                    borderColor: '#e5edf6', // <-- custom border color here
                                                    },
                                                    '&:hover fieldset': {
                                                    borderColor: '#e5edf6',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                    borderColor: '#e5edf6',
                                                    },
                                                }}}
                                            >
                                                <Select
                                                    value={id_type}
                                                    onChange={(e) => setIdType(e.target.value)}
                                                    displayEmpty
                                                    renderValue={(selected) => selected || <Typography sx={{ fontSize: 13, color: "#b8b8b8" }}>Select ID Type</Typography>}
                                                    sx={{
                                                        '& .MuiSelect-select': {
                                                        padding: '10px 14px',
                                                        minHeight: '20px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        }
                                                    }}
                                                >
                                                {idTypes.map((name) => (
                                                    <MenuItem key={name} value={name}>{name}</MenuItem>
                                                ))}
                                                </Select>
                                                <FormHelperText>{orgErrors.id_type}</FormHelperText>
                                            </FormControl>
                                            </Box>
                                            <Box sx={{ flex: 1 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>ID Number</Typography>
                                            <CustomTextField
                                                placeholder="e.g. 123456789"
                                                variant="outlined"
                                                value={id_no}
                                                onChange={(e) => setIdNumber(e.target.value)}
                                                fullWidth
                                                hiddenLabel
                                                helperText={orgErrors.id_no}
                                            />
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                Contact Number
                                            </Typography>
                                            <PhoneInput
                                                country={'ph'}
                                                value={contact_no}
                                                onChange={(value) => setContactNumber('+' + value)}
                                                inputStyle={{
                                                width: '100%',
                                                height: 45,
                                                borderRadius: 4,
                                                paddingLeft: 48,
                                                border: '1px solid #e5edf6'
                                                }}
                                                inputProps={{
                                                name: 'phone',
                                                required: true,
                                                }}
                                                enableSearch
                                            />
                                            {userErrors.contact_no && (
                                                <FormHelperText sx={{ color: 'error.main' }}>
                                                {userErrors.contact_no}
                                                </FormHelperText>
                                            )}
                                        </Box>
                                        <Box>
                                            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
                                                Date of Birth
                                            </Typography>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                value={birthdate}
                                                onChange={setBirthdate}
                                                slotProps={{
                                                textField: {
                                                    fullWidth: true,
                                                    variant: 'outlined',
                                                    helperText: userErrors.birthdate,
                                                    sx: {
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: 1,
                                                        '& fieldset': {
                                                        borderColor: '#e5edf6',
                                                        }
                                                    },
                                                    '& .MuiFormHelperText-root': {
                                                        color: 'red',
                                                        fontSize: 11,
                                                        margin: 0,
                                                    },
                                                    }
                                                },
                                                }}
                                            />
                                        </LocalizationProvider>
                                        </Box>
                                         <Grid item size={{xs: 12, sm: 12}} sx={{ textAlign: "end", mt: 3 }}>
                                            <CustomButton
                                                variant="contained"
                                                label="Create"
                                                onClick={handleSubmit}
                                                customStyles={{ fontSize: 14, mt: -3, mb: 2 }}
                                            />
                                        </Grid>
                                    </Box>
                                </Box>
                                
                            </Grid>

                           
                        </Grid>
                    </Container>
                </Box>
            {/* </Container> */}

            <CustomModal1
                open={openSavePassword}
                handleClose={handleClose}
                title="Save Password"
            >
                <SavePasswordDialogComponent createUserData={createUserData}/>
            </CustomModal1>
        </>
    )
}